//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './UIConfigurationClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';


export type EditPatientOverviewConfigurationUIConfigurationQueryParameters = {
  id: number ;
}

export type DeletePatientOverviewConfigurationUIConfigurationQueryParameters = {
  id: number ;
}

export type EditDashboardConfigurationUIConfigurationQueryParameters = {
  id: number ;
}

export type DeleteDashboardConfigurationUIConfigurationQueryParameters = {
  id: number ;
}

export type GetConfigurationUIConfigurationQueryParameters = {
  id: number ;
}

export function createPatientOverviewConfigurationUrl(): string {
  let url_ = getBaseUrl() + "/api/ui-configuration/patient-overview";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createPatientOverviewConfigurationMutationKey(): MutationKey {
  return trimArrayEnd([
      'UIConfigurationClient',
      'createPatientOverviewConfiguration',
    ]);
}

export function useCreatePatientOverviewConfigurationMutation<TContext>(options?: Omit<UseMutationOptions<number, unknown, Types.CreateUIConfigurationDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<number, unknown, Types.CreateUIConfigurationDto, TContext> {
  const key = createPatientOverviewConfigurationMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateUIConfigurationDto) => Client.createPatientOverviewConfiguration(dto),
    mutationKey: key,
  });
}
  
export function getPatientOverviewConfigurationsUrl(): string {
  let url_ = getBaseUrl() + "/api/ui-configuration/patient-overview";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getPatientOverviewConfigurationsDefaultOptions: Omit<UseQueryOptions<Types.UIConfigurationListDto[], unknown, Types.UIConfigurationListDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.UIConfigurationListDto[], unknown, Types.UIConfigurationListDto[]>, 'queryFn'>> = {
};
export function getGetPatientOverviewConfigurationsDefaultOptions() {
  return getPatientOverviewConfigurationsDefaultOptions;
};
export function setGetPatientOverviewConfigurationsDefaultOptions(options: typeof getPatientOverviewConfigurationsDefaultOptions) {
  getPatientOverviewConfigurationsDefaultOptions = options;
}

export function getPatientOverviewConfigurationsQueryKey(): QueryKey;
export function getPatientOverviewConfigurationsQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'UIConfigurationClient',
      'getPatientOverviewConfigurations',
    ]);
}
export function __getPatientOverviewConfigurations(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getPatientOverviewConfigurations(
axiosConfig    );
}

export function useGetPatientOverviewConfigurationsQuery<TSelectData = Types.UIConfigurationListDto[], TError = unknown>(options?: Omit<UseQueryOptions<Types.UIConfigurationListDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetPatientOverviewConfigurationsQuery<TSelectData = Types.UIConfigurationListDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.UIConfigurationListDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.UIConfigurationListDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getPatientOverviewConfigurations(context, axiosConfig) : __getPatientOverviewConfigurations,
    queryKey: getPatientOverviewConfigurationsQueryKey(),
    ...getPatientOverviewConfigurationsDefaultOptions as unknown as Omit<UseQueryOptions<Types.UIConfigurationListDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetPatientOverviewConfigurationsData(queryClient: QueryClient, updater: (data: Types.UIConfigurationListDto[] | undefined) => Types.UIConfigurationListDto[], ) {
  queryClient.setQueryData(getPatientOverviewConfigurationsQueryKey(),
    updater
  );
}

export function setGetPatientOverviewConfigurationsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.UIConfigurationListDto[] | undefined) => Types.UIConfigurationListDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createDashboardConfigurationUrl(): string {
  let url_ = getBaseUrl() + "/api/ui-configuration/dashboard";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createDashboardConfigurationMutationKey(): MutationKey {
  return trimArrayEnd([
      'UIConfigurationClient',
      'createDashboardConfiguration',
    ]);
}

export function useCreateDashboardConfigurationMutation<TContext>(options?: Omit<UseMutationOptions<number, unknown, Types.CreateUIConfigurationDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<number, unknown, Types.CreateUIConfigurationDto, TContext> {
  const key = createDashboardConfigurationMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateUIConfigurationDto) => Client.createDashboardConfiguration(dto),
    mutationKey: key,
  });
}
  
export function getDashboardConfigurationsUrl(): string {
  let url_ = getBaseUrl() + "/api/ui-configuration/dashboard";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDashboardConfigurationsDefaultOptions: Omit<UseQueryOptions<Types.UIConfigurationListDto[], unknown, Types.UIConfigurationListDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.UIConfigurationListDto[], unknown, Types.UIConfigurationListDto[]>, 'queryFn'>> = {
};
export function getGetDashboardConfigurationsDefaultOptions() {
  return getDashboardConfigurationsDefaultOptions;
};
export function setGetDashboardConfigurationsDefaultOptions(options: typeof getDashboardConfigurationsDefaultOptions) {
  getDashboardConfigurationsDefaultOptions = options;
}

export function getDashboardConfigurationsQueryKey(): QueryKey;
export function getDashboardConfigurationsQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'UIConfigurationClient',
      'getDashboardConfigurations',
    ]);
}
export function __getDashboardConfigurations(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getDashboardConfigurations(
axiosConfig    );
}

export function useGetDashboardConfigurationsQuery<TSelectData = Types.UIConfigurationListDto[], TError = unknown>(options?: Omit<UseQueryOptions<Types.UIConfigurationListDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetDashboardConfigurationsQuery<TSelectData = Types.UIConfigurationListDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.UIConfigurationListDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.UIConfigurationListDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getDashboardConfigurations(context, axiosConfig) : __getDashboardConfigurations,
    queryKey: getDashboardConfigurationsQueryKey(),
    ...getDashboardConfigurationsDefaultOptions as unknown as Omit<UseQueryOptions<Types.UIConfigurationListDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetDashboardConfigurationsData(queryClient: QueryClient, updater: (data: Types.UIConfigurationListDto[] | undefined) => Types.UIConfigurationListDto[], ) {
  queryClient.setQueryData(getDashboardConfigurationsQueryKey(),
    updater
  );
}

export function setGetDashboardConfigurationsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.UIConfigurationListDto[] | undefined) => Types.UIConfigurationListDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function editPatientOverviewConfigurationUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/ui-configuration/patient-overview/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function editPatientOverviewConfigurationMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'UIConfigurationClient',
      'editPatientOverviewConfiguration',
      id as any,
    ]);
}

export function useEditPatientOverviewConfigurationMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, Types.EditUIConfigurationDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.EditUIConfigurationDto, TContext> {
  const key = editPatientOverviewConfigurationMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.EditUIConfigurationDto) => Client.editPatientOverviewConfiguration(id, dto),
    mutationKey: key,
  });
}
  
type EditPatientOverviewConfiguration__MutationParameters = EditPatientOverviewConfigurationUIConfigurationQueryParameters & {
  dto: Types.EditUIConfigurationDto;
}

export function useEditPatientOverviewConfigurationMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, EditPatientOverviewConfiguration__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: EditPatientOverviewConfigurationUIConfigurationQueryParameters}): UseMutationResult<void, unknown, EditPatientOverviewConfiguration__MutationParameters, TContext> {
  const key = editPatientOverviewConfigurationMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: EditPatientOverviewConfiguration__MutationParameters) => Client.editPatientOverviewConfiguration(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function deletePatientOverviewConfigurationUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/ui-configuration/patient-overview/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deletePatientOverviewConfigurationMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'UIConfigurationClient',
      'deletePatientOverviewConfiguration',
      id as any,
    ]);
}

export function useDeletePatientOverviewConfigurationMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = deletePatientOverviewConfigurationMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.deletePatientOverviewConfiguration(id),
    mutationKey: key,
  });
}
  
type DeletePatientOverviewConfiguration__MutationParameters = DeletePatientOverviewConfigurationUIConfigurationQueryParameters

export function useDeletePatientOverviewConfigurationMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, DeletePatientOverviewConfiguration__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: DeletePatientOverviewConfigurationUIConfigurationQueryParameters}): UseMutationResult<void, unknown, DeletePatientOverviewConfiguration__MutationParameters, TContext> {
  const key = deletePatientOverviewConfigurationMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: DeletePatientOverviewConfiguration__MutationParameters) => Client.deletePatientOverviewConfiguration(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function editDashboardConfigurationUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/ui-configuration/dashboard/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function editDashboardConfigurationMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'UIConfigurationClient',
      'editDashboardConfiguration',
      id as any,
    ]);
}

export function useEditDashboardConfigurationMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, Types.EditUIConfigurationDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.EditUIConfigurationDto, TContext> {
  const key = editDashboardConfigurationMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.EditUIConfigurationDto) => Client.editDashboardConfiguration(id, dto),
    mutationKey: key,
  });
}
  
type EditDashboardConfiguration__MutationParameters = EditDashboardConfigurationUIConfigurationQueryParameters & {
  dto: Types.EditUIConfigurationDto;
}

export function useEditDashboardConfigurationMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, EditDashboardConfiguration__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: EditDashboardConfigurationUIConfigurationQueryParameters}): UseMutationResult<void, unknown, EditDashboardConfiguration__MutationParameters, TContext> {
  const key = editDashboardConfigurationMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: EditDashboardConfiguration__MutationParameters) => Client.editDashboardConfiguration(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function deleteDashboardConfigurationUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/ui-configuration/dashboard/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deleteDashboardConfigurationMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'UIConfigurationClient',
      'deleteDashboardConfiguration',
      id as any,
    ]);
}

export function useDeleteDashboardConfigurationMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = deleteDashboardConfigurationMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.deleteDashboardConfiguration(id),
    mutationKey: key,
  });
}
  
type DeleteDashboardConfiguration__MutationParameters = DeleteDashboardConfigurationUIConfigurationQueryParameters

export function useDeleteDashboardConfigurationMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, DeleteDashboardConfiguration__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: DeleteDashboardConfigurationUIConfigurationQueryParameters}): UseMutationResult<void, unknown, DeleteDashboardConfiguration__MutationParameters, TContext> {
  const key = deleteDashboardConfigurationMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: DeleteDashboardConfiguration__MutationParameters) => Client.deleteDashboardConfiguration(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function getConfigurationUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/ui-configuration/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getConfigurationDefaultOptions: Omit<UseQueryOptions<Types.UIConfigurationDto, unknown, Types.UIConfigurationDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.UIConfigurationDto, unknown, Types.UIConfigurationDto>, 'queryFn'>> = {
};
export function getGetConfigurationDefaultOptions() {
  return getConfigurationDefaultOptions;
};
export function setGetConfigurationDefaultOptions(options: typeof getConfigurationDefaultOptions) {
  getConfigurationDefaultOptions = options;
}

export function getConfigurationQueryKey(id: number): QueryKey;
export function getConfigurationQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetConfigurationUIConfigurationQueryParameters;

    return trimArrayEnd([
        'UIConfigurationClient',
        'getConfiguration',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'UIConfigurationClient',
        'getConfiguration',
        ...params
      ]);
  }
}
export function __getConfiguration(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getConfiguration(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetConfigurationQuery<TSelectData = Types.UIConfigurationDto, TError = unknown>(dto: GetConfigurationUIConfigurationQueryParameters, options?: Omit<UseQueryOptions<Types.UIConfigurationDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetConfigurationQuery<TSelectData = Types.UIConfigurationDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.UIConfigurationDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetConfigurationQuery<TSelectData = Types.UIConfigurationDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.UIConfigurationDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetConfigurationUIConfigurationQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.UIConfigurationDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getConfiguration(context, axiosConfig) : __getConfiguration,
    queryKey: getConfigurationQueryKey(id),
    ...getConfigurationDefaultOptions as unknown as Omit<UseQueryOptions<Types.UIConfigurationDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetConfigurationData(queryClient: QueryClient, updater: (data: Types.UIConfigurationDto | undefined) => Types.UIConfigurationDto, id: number) {
  queryClient.setQueryData(getConfigurationQueryKey(id),
    updater
  );
}

export function setGetConfigurationDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.UIConfigurationDto | undefined) => Types.UIConfigurationDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function resetDefaultPatientOverviewConfigurationUrl(): string {
  let url_ = getBaseUrl() + "/api/ui-configuration/patient-overview/reset";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function resetDefaultPatientOverviewConfigurationMutationKey(): MutationKey {
  return trimArrayEnd([
      'UIConfigurationClient',
      'resetDefaultPatientOverviewConfiguration',
    ]);
}

export function useResetDefaultPatientOverviewConfigurationMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = resetDefaultPatientOverviewConfigurationMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.resetDefaultPatientOverviewConfiguration(),
    mutationKey: key,
  });
}
  
export function resetDefaultDashboardConfigurationUrl(): string {
  let url_ = getBaseUrl() + "/api/ui-configuration/dashboard/reset";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function resetDefaultDashboardConfigurationMutationKey(): MutationKey {
  return trimArrayEnd([
      'UIConfigurationClient',
      'resetDefaultDashboardConfiguration',
    ]);
}

export function useResetDefaultDashboardConfigurationMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = resetDefaultDashboardConfigurationMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.resetDefaultDashboardConfiguration(),
    mutationKey: key,
  });
}